<template>
  <div class="mt-3">
    <b-form>
      <b-row>
        <b-col xl="12" lg="12" sm="12">
          <b-input-group prepend="IMSI" label-for="input-1">
            <b-form-input
                :state="true"
                v-model="resumeSubscriberForm.imsiInfo"
                required
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <hr>
      <b-row class="mt-3">
        <b-col xl="6" md="6" sm="6">
          <div class="float-left">
            <base-button type="white" title="Close" v-on:click="modalClose()">
              Close
            </base-button>
          </div>
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <div class="float-right">
            <base-button type="primary" title="Search" :disabled="submitDisabled" v-on:click="resumeSubscriberSubmit()">
              Submit
            </base-button>
          </div>
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
import provisioningService from "../../common/api-services/provisioning-service";
import ToastVue from './Toast.vue';
import configDirective from "@/common/directive/config-directive";

export default {
  name: "Resume-Subscriber",
  components: {ToastVue},
  data() {
    return {
      resumeSubscriberForm: {
        imsiInfo: ''
      }
    }
  },
  computed: {
    submitDisabled() {
      return !this.resumeSubscriberForm.imsiInfo.length > 0;
    }
  },
  mounted() {
    this.$root.$on('sendIMSIInfo', (imsi => {
      this.resumeSubscriberForm.imsiInfo = imsi;
    }))
  },
  methods: {
    async resumeSubscriberSubmit() {

      //do the IOT version
      if (configDirective.isIOTOnly()) {

        provisioningService.submitSimpleResume(this.resumeSubscriberForm.imsiInfo).then(res => {
          if (res) {
            this.$toast.success({
              component: ToastVue,
              props: {
                title: 'Resume Subscriber: OK',
                description: res.join("<br>")
              }
            }, {
              timeout: 45000
            })
            this.modalClose();
          } else {
            this.$toast.error({
              component: ToastVue,
              props: {
                title: 'Resume Subscriber: FAILED',
                description: res.join("<br>")
              }
            }, {
              timeout: 45000
            })
          }
        }).catch(err => {
          this.$toast.error({
            component: ToastVue,
            props: {
              title: 'Resume Subscriber: FAILED',
              description: JSON.stringify(err)
            }
          }, {
            timeout: 45000
          })
        });

      } else {
        this.$root.$emit('loadingPanelShow', true);

        await provisioningService.submitResumeSubscriber(this.resumeSubscriberForm.imsiInfo).then(res => {
          if (res && res.success) {
            let messageData = '<br>';
            res.success.map(item => {
              messageData = messageData + item + `<br>`
            });
            this.$toast.success({
              component: ToastVue,
              props: {
                title: 'Resume Subscriber: OK',
                description: JSON.stringify(res.data) //messageData.join("<br>")
              }
            }, {
              timeout: 45000
            })
            this.modalClose();
          } else {
            this.$toast.error({
              component: ToastVue,
              props: {
                title: 'Resume Subscriber: FAILED',
                description: JSON.stringify(res.data)
              }
            }, {
              timeout: 45000
            })
          }
        }).catch(err => {
          this.$toast.error({
            component: ToastVue,
            props: {
              title: 'Resume Subscriber: FAILED',
              description: JSON.stringify(err)
            }
          }, {
            timeout: 45000
          })
        });
      }
      this.modalClose();
    },


    modalClose() {
      setTimeout(() => {
        //this.progressMessage = 'Refreshing Subscriber data...';

        //window.location.reload();
        this.$forceUpdate();

        this.$root.$emit('reloadSimDetailPageData', this.resumeSubscriberForm.imsiInfo);

        this.$bvModal.hide('resume-subscriber');
        this.$root.$emit('loadingPanelHide', true);
      }, 1000);
    },

  }
}
</script>
